<!-- <div class="breadcrumb">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Offers</li>
    </ol>
  </nav>
</div> -->
<div class="content-info">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">Offers</h3>
    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Search offer input -->
      <div class="form-group mb-0">
        <input type="text" [(ngModel)]="offerSearchTerm" (input)="onSearch()" placeholder="Search offer..."
          class="form-control" style="min-width: 200px;" />
      </div>

      <!-- Filter toggle. Badge shows count of active filters so the
           admin can see at a glance whether the current list is
           narrowed or showing the full catalog. -->
      <button type="button" class="btn btn-outline-secondary text-nowrap" (click)="toggleFilters()">
        <i class="bi bi-funnel"></i> Filters
        @if (activeFilterCount > 0) {
          <span class="badge bg-primary ms-1">{{ activeFilterCount }}</span>
        }
      </button>

      <!-- Offers sheet: many offers of any SKU-based type in one workbook -->
      <button type="button" class="btn btn-outline-primary text-nowrap" (click)="openOffersSheetUpload()"
        title="Upload a workbook with Offers + Offer Lines sheets (BOGO, bundles, combos, bill offers…)">
        <i class="bi bi-file-earmark-spreadsheet"></i> Upload Offers Sheet
      </button>

      <!-- Add Offer button -->
      <button class="btn btnprimary text-nowrap" [routerLink]="['/create-offer']">
        <i class="bi bi-plus-lg"></i>Add Offer
      </button>
    </div>
  </div>

  <!-- ── Filter bar ───────────────────────────────────────────────────
       Standard ERP retail filter set: store (multi), offer status,
       offer type, and an "active on" date range. All filters combine
       with AND on the backend. Empty fields are simply not sent. -->
  @if (filtersExpanded) {
  <div class="offer-filters card mt-3">
    <div class="card-body">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label small fw-semibold">Store</label>
          <ng-select class="ngselect"
                     [items]="stores"
                     bindLabel="name"
                     bindValue="id"
                     [multiple]="true"
                     [loading]="storesLoading"
                     placeholder="All stores"
                     [(ngModel)]="selectedStoreIds">
          </ng-select>
        </div>
        <div class="col-md-4">
          <label class="form-label small fw-semibold">Offer Type</label>
          <ng-select class="ngselect"
                     [items]="offerTypeOptions"
                     bindLabel="label"
                     bindValue="value"
                     placeholder="Any type"
                     [(ngModel)]="selectedOfferType">
          </ng-select>
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold">Active From</label>
          <input type="date" class="form-control" [(ngModel)]="filterStartDate" />
        </div>
        <div class="col-md-2">
          <label class="form-label small fw-semibold">Active To</label>
          <input type="date" class="form-control" [(ngModel)]="filterEndDate" />
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-link text-decoration-none"
                [disabled]="activeFilterCount === 0"
                (click)="clearFilters()">
          Clear
        </button>
        <button type="button" class="btn btnprimary" (click)="applyFilters()">
          Apply
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Status tabs. Always visible so paused / expired offers are one click
       away (to reactivate or extend them), not hidden in the filter panel. -->
  <div class="offer-status-tabs mt-3" role="tablist" aria-label="Offer status">
    @for (t of statusTabs; track t.label) {
      <button type="button" role="tab" class="status-tab"
              [class.active]="selectedStatus === t.value"
              [attr.aria-selected]="selectedStatus === t.value"
              (click)="selectStatus(t.value)">
        {{ t.label }}
      </button>
    }
  </div>

  <div class="common-table">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Offer Type</th>
            <th>Status</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if(offersLoading) {
          <tr>
            <td colspan="6" class="text-center">Offers Loading...</td>
          </tr>
          } @else {
          @if(!offers.length) {
          <tr>
            <td colspan="6" class="text-center">No offers found.</td>
          </tr>
          } @else { @for(offer of offers; track offer.id) {
          <tr>
            <td>
              {{ offer.offerName }}
              <!-- Conflict indicator: this offer competes with N others on the
                   loaded page. Hovering the badge explains the resolution rule
                   so the admin knows it's expected ERP behaviour, not a bug. -->
              @if (competingOfferCount(offer) > 0) {
                <span class="badge bg-warning text-dark ms-2"
                      [title]="'Competes with ' + competingOfferCount(offer) + ' other bill offer(s) in overlapping date range. System picks the best per cart automatically.'">
                  <i class="bi bi-exclamation-triangle-fill"></i>
                  competes with {{ competingOfferCount(offer) }}
                </span>
              }
            </td>
            <td>{{ offer.offerType }}</td>
            <td>
              <!-- Derived-status pill. ACTIVE / PAUSED stay clickable (toggle
                   isActive). SCHEDULED / EXPIRED render as informational
                   badges only — clicking is a no-op (see canToggle). -->
              @switch (derivedStatus(offer)) {
                @case ('ACTIVE') {
                  <button type="button"
                          class="btn btn-sm status-pill status-on"
                          [title]="statusTooltip(offer)"
                          (click)="toggleActive(offer, $event)">
                    <i class="bi bi-check-circle-fill me-1"></i> Active
                  </button>
                }
                @case ('PAUSED') {
                  <button type="button"
                          class="btn btn-sm status-pill status-off"
                          [title]="statusTooltip(offer)"
                          (click)="toggleActive(offer, $event)">
                    <i class="bi bi-pause-circle-fill me-1"></i> Paused
                  </button>
                }
                @case ('SCHEDULED') {
                  <span class="status-pill status-scheduled"
                        [title]="statusTooltip(offer)">
                    <i class="bi bi-calendar-event-fill me-1"></i> Scheduled
                  </span>
                }
                @case ('EXPIRED') {
                  <button type="button"
                          class="btn btn-sm status-pill status-expired is-clickable"
                          [title]="statusTooltip(offer)"
                          (click)="openExtend(offer, $event)">
                    <i class="bi bi-clock-history me-1"></i> Expired
                  </button>
                }
              }
            </td>
            <!-- Offer start/end are stored as date-only values (the modal
                 uses <input type="date">, which JS serialises as midnight
                 UTC). Rendering in the user's local timezone with HH:mm
                 would surface a misleading "05:30 IST" offset — so we
                 display the calendar date only. Time-of-day restrictions
                 live in the separate startTime / endTime fields used by
                 Happy Hour offers. -->
            <td>{{ offer.startDate | date : "dd-MM-yyyy" : "UTC" }}</td>
            <td>{{ offer.endDate | date : "dd-MM-yyyy" : "UTC" }}</td>
            <td>
              <div class="td-actions-btn">
                <button class="btn btn-edit" (click)="openAddOfferDialog(offer)" data-bs-toggle="modal"
                  data-bs-target="#addOffer" title="View / Edit offer">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button type="button" class="btn btn-edit" (click)="openExtend(offer, $event)"
                  title="Extend end date / reactivate">
                  <i class="bi bi-calendar-plus"></i>
                </button>
                <button type="button" class="btn btn-trash" data-bs-toggle="modal" data-bs-target="#confirmDeleteModal"
                  (click)="openDeleteConfirmationModal(deleteConfirmationModal, offer)" title="Delete offer">
                  <i class="bi bi-trash3"></i>
                </button>
              </div>
            </td>
          </tr>
          } }
          }

        </tbody>
      </table>
    </div>
    <app-pagination [page]="currentPage" [limit]="pageSize" [total]="total" [pageCount]="pageCount"
      (pageChange)="goToPage($event)" (limitChange)="onPageSizeChange($event)">
    </app-pagination>
  </div>
</div>


<!-- Delete Modal Template -->
<ng-template #deleteConfirmationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="confirmDeleteModalLabel">Confirm Delete</h5>
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
  </div>
  <div class="modal-body delete-msg">
    <h3>Are you sure you want to delete <strong>{{ offerToDelete?.offerName }}</strong> offer?</h3>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
  </div>
</ng-template>


<!-- Pause / activate confirmation for the status pill. -->
<ng-template #toggleStatusModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="toggleStatusModalLabel">
      @if (toggleWillPause) { Pause offer? } @else { Activate offer? }
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"
      [disabled]="toggleInProgress"></button>
  </div>
  <div class="modal-body delete-msg">
    @if (toggleWillPause) {
      <h3>Pause <strong>{{ offerToToggle?.offerName }}</strong>?</h3>
      <p class="text-muted mb-0">
        It will stop applying at every POS on the next sync. You can activate it again later from this list.
      </p>
    } @else {
      <h3>Activate <strong>{{ offerToToggle?.offerName }}</strong>?</h3>
      <p class="text-muted mb-0">
        It will start applying at the POS as soon as the terminals sync, for the whole date range
        {{ offerToToggle?.startDate | date : "dd-MM-yyyy" : "UTC" }} – {{ offerToToggle?.endDate | date : "dd-MM-yyyy" : "UTC" }}.
      </p>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="modal.dismiss()" [disabled]="toggleInProgress">Cancel</button>
    <button type="button" class="btn" [class.btn-warning]="toggleWillPause" [class.btn-success]="!toggleWillPause"
      (click)="confirmToggle(modal)" [disabled]="toggleInProgress">
      @if (toggleInProgress) { <span class="spinner-border spinner-border-sm me-1"></span> }
      @if (toggleWillPause) { Pause } @else { Activate }
    </button>
  </div>
</ng-template>

<!-- Extend / reactivate: new end date, optionally switching the offer on.
     Sends only endDate (+ isActive) so nothing else about the offer changes. -->
<ng-template #extendOfferModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="extendOfferModalLabel">Extend offer</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Close"
      [disabled]="extend.saving"></button>
  </div>
  <div class="modal-body">
    <p class="mb-3">
      <strong>{{ extend.offer?.offerName }}</strong><br />
      <span class="text-muted small">
        Now {{ extend.offer?.startDate | date : "dd-MM-yyyy" : "UTC" }} – {{ extend.offer?.endDate | date : "dd-MM-yyyy" : "UTC" }}
        @if (extend.offer) { · {{ derivedStatus(extend.offer) | titlecase }} }
      </span>
    </p>
    <label class="form-label small fw-semibold" for="extendEndDate">New end date</label>
    <input id="extendEndDate" type="date" class="form-control" [(ngModel)]="extend.endDate"
      [min]="extendMinDate" [disabled]="extend.saving" />
    <div class="d-flex flex-wrap gap-2 mt-2">
      @for (d of extendPresets; track d) {
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="extendBy(d)"
          [disabled]="extend.saving">+{{ d }} days</button>
      }
    </div>
    @if (extendError) {
      <div class="text-danger small mt-2">{{ extendError }}</div>
    }
    <div class="form-check form-switch mt-3">
      <input class="form-check-input" type="checkbox" id="extendActivate" [(ngModel)]="extend.activate"
        [disabled]="extend.saving" />
      <label class="form-check-label" for="extendActivate">
        @if (extend.activate) { Active — applies at the POS } @else { Paused — saved but not applied }
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="modal.dismiss()" [disabled]="extend.saving">Cancel</button>
    <button type="button" class="btn btnprimary" (click)="confirmExtend(modal)" [disabled]="!!extendError || extend.saving">
      @if (extend.saving) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Save
    </button>
  </div>
</ng-template>

<!-- ── Offers sheet upload (multi-type) ─────────────────────────────────
     Two-sheet workbook: "Offers" (one row per offer: type, dates, stores,
     rule fields) + "Offer Lines" (one row per SKU with BUY / GET / EXCLUDE
     role). Header fields come from the sheet; only the Active switch lives
     here. Preview is a dry run; Create is all-or-nothing. -->
<ng-template #offersSheetUploadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-file-earmark-spreadsheet me-2"></i>Upload Offers Sheet
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" [disabled]="sheet.committing"
      aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="offer-status-row mb-3" [class.is-active]="sheet.isActive" [class.is-inactive]="!sheet.isActive">
      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" role="switch" id="sheetActive"
          [(ngModel)]="sheet.isActive" (ngModelChange)="onSheetFieldChange()" [disabled]="sheet.committing" />
        <label class="form-check-label fw-semibold" for="sheetActive">
          @if (sheet.isActive) {
            <span class="badge bg-success me-2"><i class="bi bi-check-circle-fill me-1"></i> ACTIVE</span>
            Offers from this sheet will apply at the POS when their date range is current.
          } @else {
            <span class="badge bg-secondary me-2"><i class="bi bi-pause-circle-fill me-1"></i> INACTIVE</span>
            Offers are created paused — they will NOT apply at the POS until activated.
          }
        </label>
      </div>
    </div>

    <div class="alert alert-light border small mb-3">
      <div class="d-flex justify-content-between align-items-start gap-3">
        <div>
          <strong>Sheet "Offers"</strong>: one row per offer — name, type, dates, stores, priority and the rule
          fields (buy / free qty, discount % / amount, special price, bill min / max, daily time window, qty slabs).<br />
          <strong>Sheet "Offer Lines"</strong>: one row per SKU — the offer it belongs to, role
          (<code>BUY</code> qualifying / discounted, <code>GET</code> reward, <code>EXCLUDE</code> never discounted),
          qty per set, and for price lists the per-SKU offer price or % with its MRP.<br />
          Covers Buy X Get Y, bundles, combos, multi-buy, price lists, progressive, happy hour, exclusions and every
          bill-level offer. Category / department / brand offers stay on the Add Offer form.
          The <em>Instructions</em> and <em>Examples</em> sheets in the template explain each type.
        </div>
        <button type="button" class="btn btn-sm btnprimary text-nowrap flex-shrink-0"
          (click)="downloadOffersSheetTemplate()">
          <i class="bi bi-download me-1"></i>Template
        </button>
      </div>
    </div>
    <div class="row g-3 mb-3">
      <div class="col-md-12">
        <label class="form-label">Excel File <span class="text-danger">*</span></label>
        <input type="file" class="form-control" accept=".xlsx,.xls" (change)="onSheetFileChange($event)"
          [disabled]="sheet.committing" />
      </div>
    </div>

    @if (sheet.preview; as p) {
      <hr />
      <div class="d-flex gap-3 mb-3">
        <span class="badge bg-secondary fs-6">{{ p.totalOffers }} offer{{ p.totalOffers === 1 ? '' : 's' }} in sheet</span>
        <span class="badge bg-success fs-6">{{ p.validOffers }} ready</span>
        @if (p.errorOffers > 0) {
          <span class="badge bg-danger fs-6">{{ p.errorOffers }} with errors</span>
        }
      </div>

      @if (p.offers?.length) {
        <h6 class="fw-semibold">Offers to be created</h6>
        <div class="table-responsive mb-3">
          <table class="table table-sm table-bordered mb-0">
            <thead class="table-light">
              <tr>
                <th>Offer</th>
                <th>Type</th>
                <th>Reward</th>
                <th>Stores</th>
                <th class="text-end">Lines</th>
                <th>Sample lines</th>
              </tr>
            </thead>
            <tbody>
              @for (o of p.offers; track o.offerName) {
                <tr>
                  <td class="fw-semibold">{{ o.offerName }}</td>
                  <td>{{ o.typeLabel }}</td>
                  <td>{{ o.reward }}</td>
                  <td>
                    @if (!o.storeNames?.length) {
                      <span class="badge bg-primary">All stores</span>
                    } @else {
                      @for (n of o.storeNames; track n) {
                        <span class="badge bg-info text-dark me-1">{{ n }}</span>
                      }
                    }
                  </td>
                  <td class="text-end">
                    {{ o.lineCount }}
                    @if (o.freeItemCount) { <br /><small class="text-success">+{{ o.freeItemCount }} get</small> }
                    @if (o.exclusionCount) { <br /><small class="text-danger">−{{ o.exclusionCount }} excl.</small> }
                  </td>
                  <td class="small text-muted">
                    @for (l of o.sample; track $index; let last = $last) {
                      <span class="badge bg-light text-dark border">{{ l.role }}</span> {{ l.sku }} {{ l.name }}
                      @if (l.detail) { · {{ l.detail }} }@if (!last) {<br />}
                    }
                    @if ((o.lineCount + o.freeItemCount + o.exclusionCount) > o.sample.length) {
                      <br />… and {{ o.lineCount + o.freeItemCount + o.exclusionCount - o.sample.length }} more
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (p.errors?.length) {
        <div class="alert alert-danger">
          <i class="bi bi-exclamation-octagon-fill"></i>
          <strong>Nothing will be created until every problem is fixed.</strong>
          Correct the rows below in your file, then choose it again and preview.
        </div>
        <div class="table-responsive" style="max-height: 260px; overflow-y: auto;">
          <table class="table table-sm table-bordered table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th>Sheet</th>
                <th>Row</th>
                <th>Column</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              @for (e of p.errors; track $index) {
                <tr>
                  <td>{{ e.sheet }}</td>
                  <td class="text-center">{{ e.row > 0 ? e.row : '—' }}</td>
                  <td class="fw-bold">{{ e.column }}</td>
                  <td class="text-danger">{{ e.error }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btnsecondary" (click)="modal.dismiss()" [disabled]="sheet.committing">
      Cancel
    </button>
    <button type="button" class="btn btn-outline-primary" (click)="previewOffersSheet()" [disabled]="!canPreviewSheet">
      @if (sheet.previewing) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Preview
    </button>
    <button type="button" class="btn btn-success" (click)="confirmOffersSheet(modal)" [disabled]="!canCommitSheet">
      @if (sheet.committing) { <span class="spinner-border spinner-border-sm me-1"></span> }
      @if (sheet.preview?.errors?.length) {
        Fix {{ sheet.preview.errors.length }} problem(s) to continue
      } @else if (sheet.preview?.offers?.length) {
        Create {{ sheet.preview.offers.length }} offer{{ sheet.preview.offers.length === 1 ? '' : 's' }}
      } @else {
        Create offers
      }
    </button>
  </div>
</ng-template>
